import React from 'react'
// import './Proj.css'

const FullPageLoader = () => {
    return (
        <div className="full-page-loader">
            {/* Add your loading spinner or animation here */}
            sending...
        </div>
    )
}

export default FullPageLoader 
